// services/onboarding.ts
import { AuthFetch } from "../hooks/useApi";
import { OnboardingRequest, OnboardingResponse } from "../types/billing.types";

export const onboardingService = {
  post: (
    apiFetch: AuthFetch,
    payload: OnboardingRequest,
  ): Promise<OnboardingResponse> =>
    apiFetch<OnboardingResponse>(`/onboarding`, {
      method: "POST",
      body:   JSON.stringify(payload),
    }),

  // Convite de acesso: em vez de criar organização própria, entra na clínica
  // do convite. A clínica vem do token do link, nunca do payload.
  postEntrarPorConvite: (
    apiFetch: AuthFetch,
    token: string,
    payload: OnboardingRequest,
  ): Promise<OnboardingResponse> =>
    apiFetch<OnboardingResponse>(`/onboarding/entrar/${encodeURIComponent(token)}`, {
      method: "POST",
      body:   JSON.stringify(payload),
    }),
};
